export default "__VITE_ASSET__C2y39wJs__"